module.exports = __webpack_public_path__ + "img/118.7.236da867.png";